import React, { useState } from 'react';
import { selectChoiceIdsWithFlights } from '../store/choices-slice';
import { useSelector } from 'react-redux';
import CalculationTableFooterPrices, { BasePriceRow } from './table-footer-prices';
import { Nav } from 'rsuite';

export default function CalculationTableFooter({ columnCount }) {
    const choiceIds = useSelector(selectChoiceIdsWithFlights);
    const [view, setView] = useState('total');

    const baselineChoiceId = choiceIds?.[0] ?? null;

    return (
        <tfoot>
            <tr>
                <td colSpan={columnCount}>
                    <Nav
                        appearance="tabs"
                        activeKey={view}
                        onSelect={(key) => setView(key)}
                    >
                        <Nav.Item eventKey="total">Gesamtpreise</Nav.Item>
                        <Nav.Item eventKey="upcharge">Aufpreise</Nav.Item>
                    </Nav>
                </td>
            </tr>
            {'upcharge' === view && baselineChoiceId && (
                <BasePriceRow choiceId={baselineChoiceId}/>
            )}
            {choiceIds.map((id) => (
                <CalculationTableFooterPrices
                    key={id}
                    choiceId={id}
                    columnCount={columnCount}
                    view={view}
                    baselineChoiceId={baselineChoiceId}
                />
            ))}
        </tfoot>
    );
}
